class ShopFormController {
    /*@ngInject*/
    constructor($log, $scope) {
        this.$scope = $scope;
        $log.debug('ShopFormController initialized');
        if (window.shopTopic) {
            this.topics = window.shopTopic.topics;
        }
        if (window.countries) {
            this.countries = window.countries.countries;
        }
        this.selectedTopic = '';
        this.topic = {
            selected: null
        };
        this.selectedCountry = '';
        this.country = {
            selected: null
        };
        this.requestPending = false;
    }

    topicChanged(item) {
        this.selectedTopic = item.code;
        this.$scope.$parent.contact.setShopAddressPanel(this.selectedCountry, this.selectedTopic);
    }

    setTopicCode(code) {
        if (code) {
            this.selectedTopic = code;
            for (let entry of this.topics) {
                if (code === entry.code) {
                    this.topic.selected = entry;
                    break;
                }
            }
        }
    }

    setCountryCode(code) {
        if (code) {
            this.selectedCountry = code;
            for (let entry of this.countries) {
                if (code === entry.code) {
                    this.country.selected = entry;
                    break;
                }
            }
        }
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }

}

export default ShopFormController;
